<template>
  <li
    class="row roomy margin-bottom-4xl"
    :style="componentStyle"
  >
    <div class="column-12 tablet:column-8 laptop:column-12 margin-bottom-lg">
      <div class="display-flex">
        <font-awesome-icon
          :icon="$v6[iconStyle][iconName]"
          fixed-width
          :size="iconSize"
        />
        <div class="margin-left-2xl">
          <slot name="title">
            <h2 class="h4">{{ title }}</h2>
          </slot>

          <slot />
        </div>
      </div>
    </div>

    <div class="column-12 tablet:column-4 tablet:text-right laptop:column-12 laptop:text-left padding-left-5xl">
      <slot name="action-primary" />

      <span
        v-if="hasSecondaryAction"
        class="display-inline-block tablet:display-block tablet:margin-top-lg laptop:display-inline-block laptop:margin-top-0 padding-x-lg"
      >
        <slot name="action-secondary" />
      </span>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'SuccessNextStep',

    props: {
      hasSecondaryAction: {
        type: Boolean,
        default: false
      },
      iconName: {
        type: String,
        default: 'faBoxes'
      },
      iconSize: {
        type: String,
        default: '2x'
      },
      iconStyle: {
        type: String,
        default: 'solid'
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      title: {
        type: String,
        default: null
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    }
  }
</script>
